import { Component, OnInit } from '@angular/core';
import { MetaService } from '../meta.service';

@Component({
  selector: 'app-vitg',
  templateUrl: './vitg.component.html',
  styleUrls: ['./vitg.component.css']
})
export class VitgComponent implements OnInit {

  constructor(private mds: MetaService) { }

  ngOnInit(): void {
    //SEO Optimization
    var strTitle = 'RegScale - Threat-Modeling with VITG';
    var description = 'RegScale integrates with VITG threat-modeling algorithms to tailor security controls based on risk';
    var keywords = 'RegScale, VITG, threat-modeling, control tailoring, FedRAMP, DHS';
    this.mds.updateTags(strTitle, keywords, description);
  }

}
